import * as tslib_1 from "tslib";
import { Component, ViewChild, Output, Input, EventEmitter, ElementRef, HostListener } from '@angular/core';
import { MapService } from './map.service';
import { LatLng } from './models';
var MapComponent = /** @class */ (function () {
    function MapComponent(service) {
        this.service = service;
        this.onCrop = new EventEmitter();
        this.onClose = new EventEmitter();
        this.path = this.service.path;
    }
    MapComponent.prototype.ngOnInit = function () {
        this.initMap();
    }; //  ngOnInit()
    MapComponent.prototype.initMap = function () {
        this.option = {
            center: this.center ? this.center : { lat: 0, lng: 0 },
            zoom: this.zoom ? this.zoom : 4,
            markers: this.markers ? this.markers : []
        };
        this.service.initMap(this.googleMap.nativeElement, this.option);
    };
    MapComponent.prototype.mapDone = function () {
        this.points = this.service.mapReturn();
        this.onCrop.emit(this.points);
    };
    // cropMap()
    MapComponent.prototype.cropChange = function () {
        this.polygon = !this.polygon;
        this.point = false;
        this.service.mapPolygon(this.polygon, this.service.map);
    };
    MapComponent.prototype.pointChange = function () {
        this.point = !this.point;
        this.polygon = false;
        this.service.mapMarker(this.point, this.service.map);
    };
    MapComponent.prototype.close = function () {
        this.onClose.emit(true);
    }; // close()
    /**
     *
     * @param ev
     * @method onKeyUp
     */
    MapComponent.prototype.onKeyUp = function (ev) {
        switch (ev.key) {
            case 'z':
                if (ev.ctrlKey) {
                    this.service.path.pop();
                    if (this.polygon) {
                        this.service.polygon.setPaths(this.service.path);
                    }
                    else {
                    }
                }
                break;
            case 'c':
                this.mapDone();
                break;
            case 'g':
                this.close();
                break;
        }
    }; // End onKeyUp()
    tslib_1.__decorate([
        ViewChild('gmap'),
        tslib_1.__metadata("design:type", ElementRef)
    ], MapComponent.prototype, "googleMap", void 0);
    tslib_1.__decorate([
        Input('zoom'),
        tslib_1.__metadata("design:type", Number)
    ], MapComponent.prototype, "zoom", void 0);
    tslib_1.__decorate([
        Input('center'),
        tslib_1.__metadata("design:type", LatLng)
    ], MapComponent.prototype, "center", void 0);
    tslib_1.__decorate([
        Input('polygon'),
        tslib_1.__metadata("design:type", Boolean)
    ], MapComponent.prototype, "polygon", void 0);
    tslib_1.__decorate([
        Input('advance'),
        tslib_1.__metadata("design:type", Boolean)
    ], MapComponent.prototype, "advance", void 0);
    tslib_1.__decorate([
        Input('point'),
        tslib_1.__metadata("design:type", Boolean)
    ], MapComponent.prototype, "point", void 0);
    tslib_1.__decorate([
        Input('markers'),
        tslib_1.__metadata("design:type", Array)
    ], MapComponent.prototype, "markers", void 0);
    tslib_1.__decorate([
        Output(),
        tslib_1.__metadata("design:type", Object)
    ], MapComponent.prototype, "onCrop", void 0);
    tslib_1.__decorate([
        Output(),
        tslib_1.__metadata("design:type", Object)
    ], MapComponent.prototype, "onClose", void 0);
    tslib_1.__decorate([
        HostListener('document:keyup', ['$event']),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [KeyboardEvent]),
        tslib_1.__metadata("design:returntype", void 0)
    ], MapComponent.prototype, "onKeyUp", null);
    MapComponent = tslib_1.__decorate([
        Component({
            selector: 'app-google-map',
            template: "<mat-toolbar class=\"map-tool-bar\" *ngIf=\"advance\"> <button mat-icon-button (click)=\"cropChange()\" mdTooltip=\"Crop (C)\"> <mat-icon> <svg viewBox=\"0 0 24 24\"> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> <path d=\"M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z\" /> </svg> </mat-icon> </button> <button mat-icon-button (click)=\"pointChange()\" mdTooltip=\"Crop (C)\"> <mat-icon> <svg viewBox=\"0 0 24 24\"> <path d=\"M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z\" /> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> </svg> </mat-icon> </button> <span class=\"spacer\"></span> <button mat-icon-button (click)=\"close()\" mdTooltip=\"Close (G)\"> <mat-icon> <svg viewBox=\"0 0 24 24\"> <path d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\" /> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> </svg> </mat-icon> </button> <!-- Second Row --> <mat-toolbar-row *ngIf=\"loading\"> <mat-progress-bar color=\"warn\" mode=\"indeterminate\"></mat-progress-bar> </mat-toolbar-row> </mat-toolbar> <div #gmap style=\"height: 100%\"> </div> <div> <button mat-fab (click)=\"mapDone()\" mdTooltip=\"Crop (C)\" *ngIf=\"(service.path?.length > 2 && polygon) || (service.path?.length > 0 && point)\" id=\"doneButton\" class=\"bottom-right\"> <mat-icon> <svg viewBox=\"0 0 24 24\"> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> <path d=\"M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z\" /> </svg> </mat-icon> </button> </div>",
            styles: [".spacer { -webkit-box-flex: 1; -ms-flex: 1 1 auto; flex: 1 1 auto; } .selected-button { color: red; } .bottom-right { position: fixed; bottom: 24px; right: 24px; } /*# sourceMappingURL=map.component.css.map */ "]
        }),
        tslib_1.__metadata("design:paramtypes", [MapService])
    ], MapComponent);
    return MapComponent;
}()); //  class
export { MapComponent };
//# sourceMappingURL=map.component.js.map